import ProductAssociationSelect from './ProductAssociationSelect';

export default ProductAssociationSelect;
